/**
 * Route names for the four module-owned SignalR hubs. Must stay identical to
 * FiveWORX.Communication.Contracts.Constants.SignalRHubNames on the backend -- there is no
 * shared package between the two deployables, so this is a duplicated constant kept in
 * sync by convention, not by the compiler.
 */
export const SignalRHubNames = {
  conversations: '/hubs/conversations',
  ticketing: '/hubs/ticketing',
  notifications: '/hubs/notifications',
  webChat: '/hubs/webchat',
  presence: '/hubs/presence',
} as const;
